import { controls, currencyToNumber, grouped } from "../../controls";

const vwspd = {
  label: "Village Wise Saral And Portal Count",
  starting: true,
  url: "vwspd",
  pageLabel: "Village Wise Saral And Portal Count",
  pageType: "history",
  visitingBranches: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Failed Requests",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      fields: ["tgc_count", "saral"],
      grandtotal: { type: "fixed", displayIn: "gl_display", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Village",
        accessor: "village",
      },
      {
        Header: "Taluka",
        accessor: "taluka_display"
      },
      {
        Header: "Portal Count",
        accessor: "tgc_count"
      },
      {
        Header: "Matched Count",
        accessor: "matched_count"
      },
      {
        Header: "Saral Count",
        accessor: "saral"
      },

    ]
  }
};

export default vwspd;